export default Object.freeze({
  PendienteDeFirma: 1,
  Coordinada: 2,
  Confirmada: 3,
  NoConfirmada: 4,
  Rechazada: 5,
  Recoordinada: 6,
  Celebrada: 7,
  NoCelebrada: 8,
  NoRespuesta: 9,
  Cancelada: 10,
});
